(() => {
  const initialize = () => document.querySelectorAll('[data-aorvo-sitewide-support] [data-aorvo-floating-support]').forEach((support) => {
    if (document.querySelector('[data-aorvo-pdp-canary]')) return;
    const root = support.closest('[data-aorvo-sitewide-support]');
    const tray = support.querySelector('[popover]');
    const launcher = support.querySelector('.aorvo-pdp-support-mobile');
    const inboxButtons = [...support.querySelectorAll('[data-aorvo-inbox]')];
    const desktop = matchMedia('(min-width: 1200px)');
    let nativeButton = null;
    let lastInvoker = null;
    let previouslyOpen = false;
    let frame = 0;
    const observed = new WeakSet();
    const closeTray = () => { if (tray.matches(':popover-open')) tray.hidePopover(); };
    const showSupport = () => {
      if (desktop.matches) { inboxButtons[0].click(); return; }
      tray.showPopover();
    };
    root.querySelectorAll('[data-aorvo-open-support]').forEach((button) => button.addEventListener('click', showSupport));
    tray.addEventListener('toggle', (event) => {
      launcher.setAttribute('aria-expanded', String(event.newState === 'open'));
      if (event.newState === 'open') tray.querySelector('button:not([disabled])').focus({ preventScroll: true });
    });
    inboxButtons.forEach((button) => button.addEventListener('click', (event) => {
      event.stopPropagation();
      if (!nativeButton) return;
      lastInvoker = desktop.matches ? inboxButtons[0] : launcher;
      closeTray();
      // Let the native outside-click listener finish the originating event first.
      setTimeout(() => nativeButton?.click(), 0);
    }));
    const updateInbox = () => {
      const host = document.querySelector('shopify-chat');
      if (!host?.shadowRoot) return;
      const roots = [host.shadowRoot];
      for (let i = 0; i < roots.length; i++) {
        const target = roots[i];
        if (!observed.has(target)) { nativeObserver.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded', 'open'] }); observed.add(target); }
        for (const element of target.querySelectorAll('*')) if (element.shadowRoot) roots.push(element.shadowRoot);
      }
      nativeButton = roots.map((target) => target.querySelector('button[part="activator"]')).find(Boolean) || null;
      if (nativeButton) {
        nativeButton.tabIndex = -1;
        nativeButton.setAttribute('aria-hidden', 'true');
        for (let wrapper = nativeButton.parentElement; wrapper; wrapper = wrapper.parentElement) wrapper.style.pointerEvents = 'none';
      }
      inboxButtons.forEach((button) => { button.disabled = !nativeButton; });
      const runtime = host.shadowRoot.querySelector('shopify-agent-runtime');
      const open = runtime?.hasAttribute('open') || nativeButton?.getAttribute('aria-expanded') === 'true';
      support.dataset.inboxOpen = String(Boolean(open));
      inboxButtons[0].setAttribute('aria-expanded', String(Boolean(open)));
      if (previouslyOpen && !open && lastInvoker?.isConnected) lastInvoker.focus({ preventScroll: true });
      previouslyOpen = Boolean(open);
    };
    const nativeObserver = new MutationObserver(updateInbox);
    customElements.whenDefined('shopify-chat').then(() => {
      const host = document.querySelector('shopify-chat');
      if (host) { updateInbox(); return; }
      const arrival = new MutationObserver(() => { if (document.querySelector('shopify-chat')) { arrival.disconnect(); updateInbox(); } });
      arrival.observe(document.body, { childList: true, subtree: true });
    });
    const position = () => {
      frame = 0;
      if (desktop.matches) { closeTray(); return; }
      const sticky = root.querySelector('[data-aorvo-sticky-form]');
      const stickyBox = sticky?.getBoundingClientRect();
      const viewportHeight = document.documentElement.clientHeight;
      let bottom = stickyBox?.height && getComputedStyle(sticky).display !== 'none' ? Math.max(16, viewportHeight - stickyBox.top + 12) : 16;
      const primary = root.querySelector('[data-aorvo-main-form] [name="add"]')?.getBoundingClientRect();
      if (primary && primary.bottom > viewportHeight - bottom - 48 && primary.top < viewportHeight - bottom && primary.right > document.documentElement.clientWidth - 60) bottom = Math.max(bottom, viewportHeight - primary.top + 12);
      support.style.setProperty('--aorvo-support-bottom', `${Math.min(bottom, viewportHeight - 60)}px`);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(position); };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    desktop.addEventListener('change', schedule);
    const sticky = root.querySelector('[data-aorvo-sticky-form]');
    if (sticky) new ResizeObserver(schedule).observe(sticky);
    schedule();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
